import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import PackageCard from "@/components/PackageCard";

const FILTERS = ["All", "Domestic", "International"];
const BANNER = "https://images.unsplash.com/photo-1488646953014-85cb44e25828?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

export default function Packages() {
  const [searchParams] = useSearchParams();
  const [packages, setPackages] = useState([]);
  const [region, setRegion] = useState("All");
  const [q, setQ] = useState(searchParams.get("q") || "");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setQ(searchParams.get("q") || "");
  }, [searchParams]);

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      api.get("/packages", { params: { region: region === "All" ? undefined : region, q: q || undefined } })
        .then((r) => setPackages(r.data))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [region, q]);

  return (
    <div>
      {/* BANNER */}
      <section className="relative h-[34vh] min-h-[240px] flex items-center justify-center overflow-hidden" data-testid="packages-banner">
        <img src={BANNER} alt="Tour packages" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-brand-navy/65" />
        <div className="relative z-10 text-center px-5">
          <h1 className="text-4xl sm:text-6xl font-heading font-semibold text-white">Tour Packages</h1>
          <p className="mt-3 text-white/80 font-body">Home &gt; Tour Packages</p>
        </div>
      </section>

      {/* CONTROLS */}
      <section className="max-w-7xl mx-auto px-5 md:px-10 -mt-8 relative z-20">
        <div className="rounded-2xl bg-white p-4 shadow-[0_12px_40px_rgba(46,42,128,0.14)] flex flex-col md:flex-row gap-4 md:items-center justify-between" data-testid="packages-controls">
          <div className="flex gap-2 rounded-full bg-brand-sand p-1.5 w-fit">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setRegion(f)}
                data-testid={`filter-${f.toLowerCase()}`}
                className={`rounded-full px-6 py-2.5 text-sm font-bold transition-colors ${
                  region === f ? "bg-brand-orange text-white" : "text-brand-navy hover:text-brand-orange"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          <div className="relative w-full md:w-80">
            <MagnifyingGlass size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#a3a1ba]" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              data-testid="packages-search"
              placeholder="Search Manali, Kerala, Dubai..."
              className="w-full rounded-full border border-brand-sand bg-brand-cream pl-11 pr-4 py-3 text-sm outline-none focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/30"
            />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-12 min-h-[40vh]">
        {loading ? (
          <p className="text-center text-[#8B89A4] py-20">Loading journeys...</p>
        ) : packages.length === 0 ? (
          <p className="text-center text-[#8B89A4] py-20" data-testid="no-packages">No packages match your search. Try another destination.</p>
        ) : (
          <>
            <p className="mb-6 text-sm text-[#8B89A4] font-body" data-testid="packages-count">{packages.length} packages found</p>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="packages-grid">
              {packages.map((p, i) => <PackageCard key={p.id} pkg={p} index={i} />)}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
